module.exports = __webpack_public_path__ + "img/log.7f4dc19c.svg";